var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.66 31.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_computer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62,10.48c.31-.2.6-.53,1-.47q17.81,0,35.61,0c.49-.06.73.43,1,.74q0,12.26,0,24.53A1.32,1.32,0,0,1,43,36H7.87a1.8,1.8,0,0,1-1.26-.49Q6.55,23,6.62,10.48ZM8,11.55V31.44H42.7q0-9.95,0-19.89Q25.36,11.55,8,11.55Z",
    transform: "translate(-6.58 -10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.23,37.09h8.24a11.38,11.38,0,0,0,.42,2.4,4.38,4.38,0,0,0,1.75,1.18,2.18,2.18,0,0,1,0,.57q-6.22,0-12.44,0l0-.63a2.69,2.69,0,0,0,2-2C21.2,38.1,21.21,37.6,21.23,37.09Z",
    transform: "translate(-6.58 -10)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComputer);
export default __webpack_public_path__ + "static/media/ic_computer.d9689da4a3ca8d8b7309be5ba53f6481.svg";
export { ForwardRef as ReactComponent };